import script from "./InspectorSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./InspectorSelect.vue?vue&type=script&lang=ts&setup=true"

import "./InspectorSelect.vue?vue&type=style&index=0&id=41d6a8b0&scoped=true&lang=scss"
import "./InspectorSelect.vue?vue&type=style&index=1&id=41d6a8b0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d6a8b0"]])

export default __exports__